import React from "react";
import PhotoCard from "./PhotoCard";
import type { Folder } from '../../../interfaces/IFolder';

const FolderSection = React.memo(({ folder, upload, remove }: { folder: Folder; upload: (folder: string, file: File) => void; remove: (folder: string, file: string) => void }) => {
  return (
    <section className="photo-section">
      <header className="section-header">
        <h2>{folder.name}</h2>

        <label className="upload-btn">
          ➕ Ajouter une image
          <input
            type="file"
            hidden
            onChange={e =>
              e.target.files && upload(folder.name, e.target.files[0])
            }
          />
        </label>
      </header>

      <div className="photo-grid">
        {folder.files.map(file => (
          <PhotoCard alt={file}
            key={file}
            src={`${import.meta.env.VITE_BACKEND_URL}/images/${folder.name}/${file}`}
            onDelete={() => remove(folder.name, file)}
          />
        ))}
      </div>
    </section>

    
            // <section key={folder.name} className="photo-section">
            //   <header className="section-header">
            //     <h2>{folder.name}</h2>

            //     <label className="upload-btn">
            //       ➕ Ajouter une image
            //       <input
            //         type="file"
            //         hidden
            //         onChange={e =>
            //           e.target.files &&
            //           upload(folder.name, e.target.files[0])
            //         }
            //       />
            //     </label>
            //   </header>

            //   <div className="photo-grid">
            //     {folder.files.map(file => (
            //       <div key={file} className="photo-card">
            //         <img
            //           src={`${import.meta.env.VITE_BACKEND_URL}/images/${folder.name}/${file}`}
            //           alt={file}
            //           loading="lazy"
            //         />
            //         <button
            //           className="delete-btn"
            //           onClick={() => remove(folder.name, file)}
            //         >
            //           ✖
            //         </button>
            //       </div>
            //     ))}
            //   </div>
            // </section>
  );
});

export default FolderSection;
